import { createSelector } from 'reselect'

const getPrivateLibrary = state => state.libraries
const baseViewSelector = createSelector(
	[getPrivateLibrary],
	library => ({
		librarySettings: library.current.settings,
		order_field: library.current.search.query.order_field,
		isAdmin: library.isAdmin,
	})
)

export default baseViewSelector
